package com.schoolconnect.app.feature.links

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.cancel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update

class LinksViewModel {
    private val scope = CoroutineScope(SupervisorJob() + Dispatchers.Default)
    private val _uiState = MutableStateFlow(LinksUiState())

    val uiState: StateFlow<LinksUiState> = _uiState.asStateFlow()

    fun onEvent(event: LinksUiEvent) {
        when (event) {
            LinksUiEvent.BackClicked -> Unit
            LinksUiEvent.RefreshClicked -> _uiState.update { it.copy(isLoading = true, errorMessage = "") }
            is LinksUiEvent.SearchChanged -> _uiState.update { it.copy(searchQuery = event.query) }
        }
    }

    fun clear() {
        scope.cancel()
    }
}

